export default __webpack_public_path__ + "static/ed-tech-6ac83595bb02a06544f0a4f4c687eb40.png";